import template from '../../templates/settings/Subscription.ejs';
import FormView from 'commons/views/Form';
import Loader from 'helpers/loader';
import Modal from 'helpers/modal';

module.exports = FormView.extend({
    events: function() {
        let parentEvents = _.isFunction(FormView.prototype.events) ?
            FormView.prototype.events() : FormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-online-payment': 'onlinePayment',
            'change #subscription-type': 'toggleYearlyInfo'
        });
    },

    initialize: function(options) {
        this.options = Object.assign({template: template}, options || {});
        FormView.prototype.initialize.apply(this, [this.options]);

        // FormView doesn't render if there is no model, but we want to
        // render the view anyway to show an error that the model is missing
        if (!this.model) {
            this.render();
        }

        this.onRedirectError();
        return this;
    },

    onRedirectError: function() {
        // catch redirects from online payments
        const hash = decodeURI(window.location.hash);
        const keyword = 'error=';
        const i = hash.indexOf(keyword);

        // return if no error
        if (i === -1) {
            return;
        }

        const errorMessage = hash.substr(i + keyword.length);

        Modal.warning({
            title: 'Payment Error',
            text: errorMessage
        });
    },

    render: function() {
        let r = FormView.prototype.render.apply(this, arguments);

        // As in the initialize method. FormView's render returns early
        // if there is no model, but we want to render the template
        // anyway
        if (!this.model) {
            this.$el.html(this.options.template(Object.assign(
                this.options.templateExtra || {}, {model: false}
            )));
            return r;
        }

        if (this.options.templateExtra.invoices.length) {
            this.$('.js-empty').hide();
        } else {
            this.$('.js-table-invoices').hide();
        }

        this.toggleYearlyInfo();

        return r;
    },

    onlinePayment: function(e) {
        e.preventDefault();

        const invoiceId = $(e.currentTarget).data('id');
        const invoice = this.options.templateExtra.invoices
            .find(i => i.id === invoiceId);

        if (!invoice) {
            return false;
        }

        this.model.onlinePayment(invoiceId)
            .then(response => {
                window.location.replace(response.result.url);
            });
    },

    save: function(ev) {
        const $button = this.$(ev.currentTarget);
        const stopLoader = Loader.startFullScreen($button);
        if (app.user.isAdmin()) {
            if (this.$('select[name="type"]').val() === 'yearly') {
                const yearlyInvoice = this.model.get('yearlyInvoice') || {};
                this.model.set('yearlyInvoice', Object.assign(
                    yearlyInvoice,
                    {
                        id: this.$('#yearlyInvoiceId').val(),
                        payslipCount: parseInt(
                            this.$('#yearlyInvoicePayslipCount').val() || 0,
                            10
                        ),
                    }
                ));
            }

            const discountName = this.$('#discount').val();
            if (!discountName) {
                this.model.set({
                    couponCode: ''
                });
            } else {
                const discountCode = this.options.templateExtra.discountCodes
                    .find(code => [
                        // jscs:disable
                        code.invoice_name, code.name
                    ].includes(discountName));

                if (!discountCode) {
                    stopLoader();
                    Modal.warning({
                        text: `Invalid discount specified. Please choose \
                        from the dropdown list`
                    });
                    return;
                }
                this.model.set({
                    couponCode: discountCode.id
                });
            }
        }

        this.model.save()
            .then(() => {
                Modal.showAlertSuccess('Your changes have been saved');
            })
            .catch(() => {
                Modal.error({
                    text: 'Please contact customer support'
                });
            })
            .finally(() => stopLoader());
    },

    toggleYearlyInfo: function() {
        const subsType = this.$('#subscription-type').val();

        if (subsType === 'yearly') {
            this.$('.yearly-info').show();
        } else {
            this.$('.yearly-info').hide();
        }
        this.model.set({type: subsType});
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Subscription.js